import React, { Suspense } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
import Meeting from "../pages/Meeting/MeetingNative";
import MeetingNativeForMobile from "../pages/Meeting/MeetingNativeForMobile";
import MeetingOverPage from "../pages/Meeting/MeetingOverForMobile";

const NoMatchPage = () => {
  window.location.href = process.env.REACT_APP_LMS_URL;
  return <div></div>;
};

const AppRoute = () => {
  return (
    <>
      <Router>
        <Suspense fallback={<p>Loading...</p>}>
          <Switch>
            <Route
              exact
              path="/meeting-mobile"
              component={MeetingNativeForMobile}
            />
            <Route
              exact
              path="/meeting-over-mobile"
              component={MeetingOverPage}
            />
            <PrivateRoutes exact path="/" component={Meeting} />
            <Route exact path="*" component={NoMatchPage} />
          </Switch>
        </Suspense>
      </Router>
    </>
  );
};

export default AppRoute;
